import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { YearlyDateDTOBase } from "./YearlyDateDTOBase";
import type { YearlyDateItemStaff } from "./YearlyDateItemStaff";

export class YearlyDateStaff implements YearlyDateDTOBase {
  constructor(public readonly dateId: number, public readonly year: number | null, public readonly itemId: YearlyDateItemStaff | null, public readonly startDate: Date | null, public readonly endDate: Date | null) {
    this.cbiServiceContext = null;
    this.itemIdLoaded = this.itemId != null;
    this.itemIdCached = this.itemId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemIdLoaded: boolean;
  private itemIdCached: YearlyDateItemStaff | null;
  async itemIdLazy(): Promise<YearlyDateItemStaff | null> {
    if (!this.itemIdLoaded) {
      this.itemIdCached = await this.cbiServiceContext!.calendarService().getYearlyDateStaffItemId(this.dateId);
      this.itemIdLoaded = true;
    }
    return this.itemIdCached;
  }
}
